import * as React from "react";
import { SVGs } from "../../assets";
import {
  Button,
  CheckBox,
  Divider,
  Modal,
  Text,
  TextField,
  Trans,
} from "../../components";
import type { LoginViewModel } from "./viewModel";

function TermsAndConditions({
  t,
  onAccept = () => {},
}: {
  t: LoginViewModel["t"];
  onAccept?: () => void;
}) {
  const [isAccepted, setIsAccepted] = React.useState(false);
  return (
    <div className="">
      <Text>
        <Trans i18nKey="login.terms.intro" />
      </Text>
      <Divider className="my-[16px]" />
      <Text>{t("login.terms.details")}</Text>
      <CheckBox
        className="my-[24px]"
        label={t("login.terms.checkboxLabel")}
        value={isAccepted}
        onChange={setIsAccepted}
      />
      <Button
        color="secondary"
        className="w-full"
        onClick={onAccept}
        disabled={!isAccepted}
        children={t("login.terms.acceptCta")}
      />
    </div>
  );
}

export function View(props: LoginViewModel) {
  const { t } = props;
  return (
    <div className="flex items-center justify-center pt-[100px] px-4 py-10">
      <div className="w-full max-w-[540px] flex flex-col items-center">
        <img src={SVGs.logo} alt="Health 4 Travel" className="h-[40] w-auto" />
        <Text level={1} className="mt-[24px]">
          {t("login.title")}
        </Text>
        <Text className="mt-[8px]">{t("login.subtitle")}</Text>
        <form onSubmit={(e) => e.preventDefault()}>
          <TextField
            value={props.email}
            className="mt-[24px]"
            classNames={{ container: "h-[50px]" }}
            placeholder={t("login.emailPlaceholder")}
            onChange={(e) => props.setEmail(e.currentTarget.value)}
          />
          <Text className="mt-[8px] text-text-disabled">
            {t("login.emailHelper")}
          </Text>
          <Button
            type="submit"
            ref={props.buttonRef}
            onClick={props.onLogin}
            children={t("login.signInCta")}
            className="mt-[24px] w-full"
            disabled={props.isSubmitDisabled}
          />
        </form>
      </div>
      <Modal title={t("login.terms.modalTitle")} ref={props.modalRef}>
        <TermsAndConditions t={t} onAccept={props.acceptTermsAndContinue} />
      </Modal>
    </div>
  );
}
